export default __webpack_public_path__ + "static/media/taxi.5cbd7318.svg";